module.exports = __webpack_public_path__ + "img/words5.9e45e978.png";